require('angular')
TermService = require('./term-service')
TermInterceptor = require('./term-interceptor')

angular.module 'gnp-term', []
  .factory 'TermService', TermService
  .factory 'TermInterceptor', TermInterceptor
  .config ['$httpProvider', ($httpProvider) ->
    $httpProvider.interceptors.push('TermInterceptor')
  ]
  .value('returnUrlAfterTerm', url: '/')




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/term/term-module.coffee